<template>
  <div class="button-line-wrap button-line-wrap_line-top">
    <button
      type="button"
      class="btn btn-size-s button-line"
      :class="classes"
      :disabled="disabled"
      @click.stop.prevent="handlerClick">
        <slot></slot>
    </button>
  </div>
</template>

<script>
const L10n = window.app.L10n
export default {
  name: 'ButtonLine',
  props: {
    text: { type: String, default: L10n('text') },
    disabled: { type: Boolean, default: false },
    classes: { type: [ String, Object, Array ] }
  },
  methods: {
    handlerClick (e) {
      if (this.disabled) return
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="stylus">
  .button-line-wrap{
    display flex
    justify-content center
    &_line-top{
      border-top 1px solid #e7e7e9
      .button-line{
        border-radius 0 0 .7rem .7rem !important
      }
    }
  }
  .button-line{

  }
</style>
